/** Shared formatting and column helpers of the Гүйлгээний Баримт module. */

export function receiptOptions(t) {
    return [
        { label: t("receipt.has"), value: "true" },
        { label: t("receipt.hasNot"), value: "false" },
    ];
}

export function getPreviewStatusLabel(value, t) {
    if (value === "OK") return t("excel.status.ok");
    if (value === "DUPLICATE_IN_FILE") return t("excel.status.dupFile");
    if (value === "DUPLICATE_IN_DB") return t("excel.status.dupDb");
    if (value === "INVALID") return t("excel.status.invalid");
    return value || "-";
}

export function getPreviewStatusColor(value) {
    if (value === "OK") return "green";
    // Duplicates still import - amber marks them as a warning, not a blocker.
    if (value === "DUPLICATE_IN_FILE") return "orange";
    if (value === "DUPLICATE_IN_DB") return "gold";
    if (value === "INVALID") return "red";
    return "default";
}

export function formatReceiptAmount(value) {
    if (value === null || value === undefined || value === "") return "-";

    const number = Number(value);
    if (!Number.isFinite(number)) return "-";

    return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/** The rate keeps up to four decimals, without padding a whole number with zeros. */
export function formatReceiptRate(value) {
    if (value === null || value === undefined || value === "") return "-";

    const number = Number(value);
    if (!Number.isFinite(number)) return "-";

    return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
    });
}

export function formatReceiptDate(value) {
    if (!value) return "-";
    return String(value).slice(0, 10);
}

export function formatFileSize(bytes) {
    if (!bytes && bytes !== 0) return "-";

    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

/** Maps the Ant Design sorter object onto the backend sortField / sortOrder parameters. */
export function mapSorter(sorter) {
    const active = Array.isArray(sorter)
        ? sorter.find((item) => item?.order)
        : sorter;

    if (!active?.order) {
        return { sortField: undefined, sortOrder: undefined };
    }

    return {
        sortField: active.field || active.columnKey,
        sortOrder: active.order === "ascend" ? "asc" : "desc",
    };
}

/**
 * Turns the shared form values into the API payload used by create and update.
 *
 * "Нийт үнийн дүн" is never sent: the server derives it from amount x rate. An empty rate is
 * sent as an explicit null, so clearing it on an existing row actually clears it.
 */
export function buildTransactionReceiptPayload(values) {
    return {
        name: values.name.trim(),
        currency: values.currency,
        institution: values.institution?.trim() || null,
        amount: values.amount,
        rate: values.rate ?? null,
        executionDate: values.executionDate
            ? values.executionDate.format("YYYY-MM-DD")
            : null,
    };
}
